import React from 'react';
import { Link, useLocation } from 'react-router-dom';
export function ServiceNowSubNav() {
  const location = useLocation();
  const isActive = (path: string) => {
    if (path === '/services/servicenow') {
      return location.pathname === '/services/servicenow' || location.pathname === '/services/servicenow/';
    }
    return location.pathname.startsWith(path);
  };
  const tabs = [{
    name: 'Home',
    path: '/services/servicenow'
  }, {
    name: 'Services',
    path: '/services/servicenow/services'
  }, {
    name: 'Secure On-Premise',
    path: '/services/servicenow/secure-on-premise'
  }, {
    name: 'Thought Leadership',
    path: '/services/servicenow/thought-leadership'
  }, {
    name: 'Case Studies',
    path: '/services/servicenow/case-studies'
  }];
  return <div className="bg-nrs-light border-b border-gray-200 sticky top-20 z-40" data-id="element-271" data-mp="3sntp0f198fs6">
      <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15" data-id="element-272" data-mp="3spy3fqws4x6p">
        <div className="flex items-center justify-between h-14" data-id="element-273" data-mp="3nql7mgnxkfrz">
          <div className="flex space-x-6 md:space-x-8 h-full overflow-x-auto" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-274" data-mp="1a3ixn0ljyj3">
            {tabs.map(tab => <Link key={tab.path} to={tab.path} className={`inline-flex items-center h-full px-1 border-b-2 text-sm font-bold transition-colors whitespace-nowrap ${isActive(tab.path) ? 'border-nrs-orange text-nrs-navy' : 'border-transparent text-gray-500 hover:text-nrs-orange hover:border-gray-300'}`} data-id="element-275" data-mp="a9gssgsmup4c">
                {tab.name}
              </Link>)}
            {/* Mobile only calculator tab */}
            <Link to="/services/servicenow/calculator" className={`md:hidden inline-flex items-center h-full px-1 border-b-2 text-sm font-bold transition-colors whitespace-nowrap ${isActive('/services/servicenow/calculator') ? 'border-nrs-orange text-nrs-orange' : 'border-transparent text-nrs-orange hover:text-nrs-orange-dark'}`} data-id="element-276" data-mp="szyj6epzt8mj">
              Risk Calculator
            </Link>
          </div>
          <div className="hidden md:block pl-4" data-id="element-277" data-mp="6w68us1ezav1">
            <Link to="/services/servicenow/calculator" className={`btn-primary py-2 px-4 text-sm ${isActive('/services/servicenow/calculator') ? 'ring-2 ring-offset-2 ring-nrs-orange' : ''}`} data-id="element-278" data-mp="6wpog23ldn5w">
              Risk Calculator
            </Link>
          </div>
        </div>
      </div>
    </div>;
}